/* eslint-disable */
import {
    Card,
    CardContent,
    Grid,
    RACButton,
    RACSelect,
    RACTextbox,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { ZoneBasedPricingContext } from './ZoneBasedPricingContext';
import { filterHierarchy, mapDropDownData } from '../../../utils/utils';
import { MultiSelect } from 'react-multi-select-component';

export default function ZoneBasedPricingFilter(props: any) {
    const classes = CostBasedPricingStyles();
    const { zoneBasedPricingSearchData, setZoneBasedPricingSearchData,
        deptOptions, subDeptOptions, setsubDeptOptions,
        bracketOptions, setbracketOptions, zoneOptions, loader,
        dropDownData, setZoneBasedPricingGridContent, searchZoneBasedPricingDetails,
        zoneSelected, setZoneSelected, setPageDisplay
    } = useContext(ZoneBasedPricingContext);
    console.log(zoneBasedPricingSearchData, 'zoneBasedPricingSearchDatazoneBasedPricingSearchData')
    function bindHierarchyDropDown(data: any[], filterKey: string, value: string | number, type: string) {
        const filteredData = filterHierarchy(data, filterKey, value);
        const dropDownData = mapDropDownData(filteredData, "descEn", type);
        if (type == 'subdepartmentNumber') {
            setsubDeptOptions(dropDownData)
        } else if (type == 'bracketNumber') {
            setbracketOptions(dropDownData)
        }
    }

    return (
        <Grid container md={12} style={{marginBottom: '20px'}}>
            <Card className={classes.card} style={{ overflow: "visible" }}>
                <CardContent style={{ overflow: "visible" }}>
                    <Grid container md={12} spacing={2}>
                        <Grid item md={2}>
                            <Typography>Zone<span style={{ color: "red" }}>*</span>
                            </Typography>
                            <MultiSelect
                                isLoading={loader.dropdownLoader}
                                options={zoneOptions}
                                className={`${classes.demo}  ${classes.prcingzoneMultiSelect} `}
                                value={zoneSelected}
                                labelledBy={"Select"}
                                hasSelectAll={true}
                                onChange={(e: any) => {
                                    setZoneSelected(e);
                                    let arr = e.map((item: any) => {
                                        if (item.value == item.value) return item.value;
                                    });
                                    setZoneBasedPricingSearchData({ ...zoneBasedPricingSearchData, zone: (arr.length != dropDownData.zone.length) ? arr : undefined })
                                }}
                            />
                        </Grid>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Department"
                                required={true}
                                defaultValue={zoneBasedPricingSearchData?.department}
                                options={deptOptions}
                                loading={loader.dropdownLoader}
                                onChange={(e) => {
                                    setZoneBasedPricingSearchData({
                                        ...zoneBasedPricingSearchData, department: e.target.value,
                                        subdepartment: '', bracket: ''
                                    })
                                    bindHierarchyDropDown(dropDownData?.subdepartment, 'departmentNumber', e.target.value, 'subdepartmentNumber')
                                }}
                            />
                        </Grid>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Sub Department"
                                defaultValue={zoneBasedPricingSearchData?.subdepartment}
                                options={subDeptOptions}
                                isDisabled={zoneBasedPricingSearchData?.department ? false : true}
                                onChange={(e) => {
                                    setZoneBasedPricingSearchData({ ...zoneBasedPricingSearchData, subdepartment: e.target.value, bracket: '' })
                                    bindHierarchyDropDown(dropDownData?.bracket, 'subdepartmentNumber', e.target.value, 'bracketNumber')
                                }}
                            />
                        </Grid>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Bracket"
                                defaultValue={zoneBasedPricingSearchData?.bracket}
                                options={bracketOptions}
                                isDisabled={(zoneBasedPricingSearchData?.department &&
                                    zoneBasedPricingSearchData?.subdepartment) ? false : true}
                                onChange={(e) => {
                                    setZoneBasedPricingSearchData({ ...zoneBasedPricingSearchData, bracket: e.target.value })
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container md={12}>
                        <Grid item md={12}>
                            <RACButton
                                color="primary"
                                variant="contained"
                                size="small"
                                className={`${classes.floatRight}`}
                                disabled={(zoneBasedPricingSearchData?.department && (zoneBasedPricingSearchData?.zone?.length || zoneBasedPricingSearchData?.zone == undefined)) ? false : true}
                                onClick={() => {
                                    if ((zoneBasedPricingSearchData.zone?.length || zoneBasedPricingSearchData.zone == undefined) && zoneBasedPricingSearchData.department) {
                                        setZoneBasedPricingGridContent([])
                                        searchZoneBasedPricingDetails()
                                        setPageDisplay(0)
                                    }
                                }}
                            >
                                Apply
                            </RACButton>
                            <RACButton
                                color="primary"
                                variant="outlined"
                                size="large"
                                className={`${classes.floatRight} ${classes.mR1} ${classes.padding6}`}
                                disabled={(zoneBasedPricingSearchData?.department || (zoneBasedPricingSearchData?.zone?.length || zoneBasedPricingSearchData?.zone == undefined)) ? false : true}
                                onClick={() => {
                                    setZoneSelected([])
                                    setZoneBasedPricingSearchData({
                                        ...zoneBasedPricingSearchData, department: '', subdepartment: '', bracket: '', zone: ''
                                    })
                                }}
                            >
                                Clear
                            </RACButton>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid >
    );
}
